import type { FC } from 'react'
import type { ThesaurusEntry } from '../../types/wordTools'
import { SenseCard } from './SenseCard'

interface ThesaurusIndexViewProps {
  entries: ThesaurusEntry[]
  word: string
  onSenseClick: (entry: ThesaurusEntry) => void
}

/**
 * Scrollable list of thesaurus sense cards.
 * Displays all available senses for a word with click/keyboard navigation.
 */
export const ThesaurusIndexView: FC<ThesaurusIndexViewProps> = ({
  entries,
  word,
  onSenseClick
}) => {
  if (entries.length === 0) {
    return (
      <div
        data-testid="thesaurus-index-empty"
        className="flex flex-col items-center justify-center py-12 px-4 text-center"
      >
        <div className="text-gray-500 mb-2">
          No senses found for <span className="font-medium">"{word}"</span>
        </div>
        <div className="text-sm text-gray-400">
          Try a different word or check spelling
        </div>
      </div>
    )
  }

  return (
    <div
      data-testid="thesaurus-index-view"
      className="space-y-2 p-4 overflow-y-auto"
    >
      {entries.map(entry => (
        <SenseCard
          key={entry.number}
          entry={entry}
          onClick={onSenseClick}
        />
      ))}
    </div>
  )
}
